"use strict";

import angular from "angular";

import { User } from "../../../gateway/User/User";
import { UserDataAdapter } from "../../../presentation/adpters/UserDataAdapter";

export class DialogChangeTempPassword {
    User = new User();
    user = new UserDataAdapter().user();
    constructor($mdDialog, locals) {
        this.$mdDialog = $mdDialog;
        this.locals = locals;
    }

    $onInit() {
        this.pwdShow = false;
        this.pwdConfirmShow = false;
    }

    onCancel() {
        this.$mdDialog.cancel();
    }

    async onChangePassword() {
        this.User.setPassword(this.user._id, this.document.data.password);
        this.$mdDialog.hide();
    }

    showPassword(elementId) {
        if (!elementId) return;
        const element = angular.element(document.getElementById(elementId))[0];
        element.type === "password"
            ? (element.type = "text")
            : (element.type = "password");
    }

    onShowPassword() {
        this.pwdShow = !this.pwdShow;
        this.pwdConfirmShow = !this.pwdConfirmShow;
        this.showPassword("password");
        this.showPassword("pwdConfirmShow");
    }
}

angular.module("nucont.shared").controller("DialogChangeTempPassword", [
            "$mdDialog",
            "locals",
            DialogChangeTempPassword
        ]);
